import axios from 'axios'
import { clearToken, getToken } from '../utils/auth'

const http = axios.create({
  baseURL: 'https://friend-api.martinself.cn/api',
  timeout: 10000
})

http.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.authorization = `Bearer ${token}`
  }
  return config
})

http.interceptors.response.use(
  (res) => {
    const body = res.data
    if (!body || body.code !== 0) {
      const msg = (body && body.msg) || '请求失败'
      if (msg.includes('未授权') || msg.includes('Token') || msg.includes('登录')) {
        clearToken()
        location.hash = '#/login'
      }
      return Promise.reject(new Error(msg))
    }
    return body.data
  },
  (error) => Promise.reject(error)
)

export default http
